import script from "./ComplaintDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintDetail.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintDetail.vue?vue&type=style&index=0&id=60541098&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60541098"]])

export default __exports__